import { Object3D } from 'three'
import { Battle } from '../../../d.controllers/BattleController'
import GameObject from './GameObject'
import { GAME_OBJECTS } from './types'

export default class Interactive extends GameObject {
  constructor(obj: Object3D) {
    super(obj)
    this.types.push(GAME_OBJECTS.INTERACTIVE)
  }

  isSelectable() {
    return true
  }
  canInteract() {
    return true
  }
  performInteraction() {
    Battle.resolveInteraction(this)
  }

  // mothod called after complicated resolution of pointer interaction into onPointerDownHandler script helper.
  onSelect() {
    if (this.isSelectable()) {
      // in case of characters updates zustand but in case of tiles and treasure we shouldn't
      // can't see right now some common code to put here.
    } else if (this.canInteract()) {
      // console.log('yes, can interact');
      
      this.performInteraction()
    }
  }
}
